module.exports = __webpack_public_path__ + "static/002-a4122eac724b040efa9fd2453dd7c7be.jpg";